import React from "react";
import Skeleton from "react-loading-skeleton";

function NavbarSkeleton() {
  return (
    <div
      className={`flex  gap-10 lg:h-16 lg:mt-0 mt-5 h-auto items-center transition-all duration-300 lg:flex-row lg:w-auto flex-col w-full`}
    >
      <Skeleton height={20} width={70} baseColor="#ccc" borderRadius={8} />
      <Skeleton height={20} width={70} baseColor="#ccc" borderRadius={8} />
      <Skeleton height={20} width={70} baseColor="#ccc" borderRadius={8} />
      <Skeleton height={20} width={70} baseColor="#ccc" borderRadius={8} />
      <Skeleton height={20} width={70} baseColor="#ccc" borderRadius={8} />
      <Skeleton height={20} width={70} baseColor="#ccc" borderRadius={8} />
    </div>
  );
}

export default NavbarSkeleton;
